import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { ISpinnerProps } from "../types/ISpinner";

export const Spinner = (props: ISpinnerProps) => {
    return (
        <ProgressSpinner
            style={{ width: `${props.width}px`, height: `${props.height}px` }}
            strokeWidth="4"
            animationDuration="2s"
        />
    );
};
